import { useCallback, useState } from "react";

import PageLoading from "components/loading/PageLoading";
import FullScreenModal from "ds/components/FullScreenModal";
import { showSimpleLeaveConfirmation } from "ds/components/LeaveConfirmationModal/Simple";
import useErrorHandle from "hooks/useErrorHandle";
import useTitle from "hooks/useTitle";

import { ORIGIN_INTEGRATION_NAME } from "../../constants";
import useCloseFullScreenModal from "../../useCloseFullScreenModal";
import VCSIntegrationsManageOriginManual from "../Manual";
import useGetOriginIntegration from "./useGetOriginIntegration";

const VCSIntegrationsManageOriginEdit = () => {
  const [isDirty, setIsDirty] = useState(false);

  const { integration, isPageLoading, error } = useGetOriginIntegration();
  const { handleOnClose } = useCloseFullScreenModal();

  const modalCloseClickHandler = useCallback(async () => {
    if (isDirty) {
      await showSimpleLeaveConfirmation();
    }

    handleOnClose();
  }, [handleOnClose, isDirty]);

  const toggleIsDirty = useCallback((value: boolean) => {
    setIsDirty(value);
  }, []);

  useTitle(`Edit integration · ${ORIGIN_INTEGRATION_NAME}`);

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  return (
    <FullScreenModal title="Edit Origin integration" onClose={modalCloseClickHandler}>
      {isPageLoading && <PageLoading />}
      {!isPageLoading && (
        <VCSIntegrationsManageOriginManual
          integration={integration}
          onIsDirtyChange={toggleIsDirty}
        />
      )}
    </FullScreenModal>
  );
};

export default VCSIntegrationsManageOriginEdit;
